// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"341":"94783b44","543":"e66794fc","906":"34e9f12d"}[chunkId] + ".chunk.js";
};